const resources = {
    greeting: 'Bonjour',
    signIn: 'Ouvrir une session',
    signInPrompt: 'pour profiter de l’expédition GRATUITE',
    biHeading: 'Résumé Beauty Insider',
    biDesc: 'Voir l’activité, les économies et les avantages',
    joinNow: 'S’inscrire',
    rewardsHeading: 'Rewards Bazaar',
    rewardsDesc: 'Réclamez des articles, des échantillons et plus',
    pointsLabel: 'Point',
    chooseBirthdayGift: 'Choisissez votre cadeau d’anniversaire!',
    ccHeading: 'Programme de carte de crédit Sephora',
    ccDesc: 'Consulter et gérer les cartes de crédit et les récompenses',
    ccRewardsLabel: 'Récompenses',
    ccApplyNow: 'S’inscrire',
    ordersHeading: 'Commandes',
    ordersDesc: 'Consulter et faire le suivi des commandes en ligne ou à ramasser',
    autoReplenishHeading: 'Réapprovisionnement automatique',
    autoReplenishDesc: 'Afficher et gérer vos abonnements',
    purchasesHeading: 'Acheter de nouveau',
    purchasesDesc: 'Commandez de nouveau les achats en magasin et en ligne',
    lovesHeading: 'Favoris',
    lovesDesc: 'Voir les produits conservés',
    recHeading: 'Recommandations des conseillers beauté',
    recDesc: 'Recommandations selon vos visites en magasin',
    reservationsHeading: 'Réservations',
    reservationsDesc: 'Gérez vos services, vos ateliers et vos événements',
    beautyPrefHeading: 'Préférences beauté',
    beautyPrefDesc: 'Remplir pour des recommandations personnalisées',
    accountHeading: 'Paramètres du compte',
    accountDesc: 'Paiement, coordonnées, adresses, mot de passe',
    signOut: 'Se déconnecter',
    sameDayUnlimitedHeading: 'Livraison le jour même illimitée',
    sameDayUnlimitedMemberDesc: 'Gérer votre abonnement',
    sameDayUnlimitedNonMemberDesc: 'Obtenez la livraison gratuite le jour même illimitée',
    subscribeToday: 'S’inscrire aujourd’hui',
    createAccount: 'Créer un compte',
    noAccount: 'Vous n’avez pas de compte?',
    signInForShipping: 'Ouvrez une session pour profiter de la *livraison GRATUITE*!',
    helloBeautiful: 'Bonjour, beauté!',
    beautyChallenges: 'Défis Beauty Insider',
    new: 'NOUVEAUTÉ',
    beautyChallengesDescription: 'Accumulez des points en accomplissant des tâches'
};

export default function getResource(label) {
    return resources[label];
}
